import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';

import './global.css';

import ThemeProvider from './components/globals/ThemeProvider';
import { PostMessageAction, sendMessage } from './lib/postMessage';
import { trpc, trpcReactClient } from './lib/trpc';
import Pages from './pages';

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: error => {
      console.log(error);
    }
  }),

  defaultOptions: {
    queries: {
      gcTime: 0,
      staleTime: 0,
      refetchOnWindowFocus: false,
      retry: false
    },
    mutations: {
      gcTime: 0,
      onError(error) {
        console.log(error);
      }
    }
  }
});

export default function App() {
  useEffect(() => {
    sendMessage(PostMessageAction.APP_LOADED, { loadedAt: new Date().toISOString() });
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <trpc.Provider client={trpcReactClient} queryClient={queryClient}>
        <ThemeProvider>
          <BrowserRouter>
            <Pages />
          </BrowserRouter>
        </ThemeProvider>
      </trpc.Provider>
    </QueryClientProvider>
  );
}
